// @ts-nocheck
import React, { useState, useRef, useEffect, useContext } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import authService from './authService';
import { savePage2DataHybrid, getPage2DataHybrid, getAllBookings, getFloorplan, getPage1DataHybrid, getYachtItems, getMasterItems, getMasterSections, getPage5Agreement } from './services/apiService';
import { savePageMedia } from './utils/mediaStorage';
import { SHOW_PER_PAGE_SIGNATURES } from './config/featureFlags';
import { DataContext } from './App';
import { isPastCheckoutGrace } from './utils/charterWindow';
import { syncCheckinPreview } from './utils/previewMode';
import {
  compressImage,
  getBase64Size,
  compressImageWithLogging,
  compressSignature,
  brand,
  // EMPLOYEE_CODES, // removed - using authService
  uid,
  mid,
  I18N,
  BookingInfoBox,
  SHOW_BOOKING_INFO_ON_CHECKLIST_PAGES,
  TailwindButton,
  PageHeader,
  TopControls,
  ModeDisplay,
  ActionButtons,
  SignatureBox,
  TableSection
} from "./shared-components";

// ========= Page 4 Specific Keys =========
const KITCHEN_KEYS = [
  "electric_fridge",
  "gas_stove_4_heads",
  "dinner_plates",
  "soup_plates",
  "glasses_water",
  "glasses_wine",
  "knives",
  "forks",
  "spoons"
];

const NAV_KEYS = [
  "gps_plotter",
  "vhf_dsc",
  "binoculars",
  "charts"
];

const SAFETY_KEYS: string[] = [];

const GEN_KEYS = ["generator"];

const DECK_KEYS = [
  "spare_anchor",
  "deck_brush",
  "gangway"
];

const FDECK_KEYS = [
  "lines_20m",
  "lines_50m"
];

const DINGHY_KEYS = [
  "inflatable_dinghy",
  "oars",
  "air_pump"
];

const FENDERS_KEYS = [
  "bow_fenders",
  "stern_fenders"
];

const BOATHOOK_KEYS = ["telescopic_boathook"];

export const ITEM_LABELS = {
  electric_fridge: { en: "Electric fridge", el: "Ηλεκτρικό ψυγείο", it: "frigorifero elettrico", de: "Elektrokühlschrank", ru: "электрический холодильник", fr: "réfrigérateur électrique", ro: "frigider electric", pl: "lodówka elektryczna", he: "מקרר חשמלי", es: "nevera eléctrica" },
  gas_stove_4_heads: { en: "Gas stove – 4 heads", el: "Εστία αερίου – 4 μάτια", it: "fornello a gas 4 fuochi", de: "Gasherd 4 Flammen", ru: "газовая плита 4 конфорки", fr: "cuisinière gaz 4 feux", ro: "aragaz 4 ochiuri", pl: "kuchenka gazowa 4 palniki", he: "כיריים גז 4 להבות", es: "cocina gas 4 fuegos" },
  dinner_plates: { en: "Dinner plates", el: "Πιάτα φαγητού", it: "piatti da portata", de: "Teller", ru: "тарелки обеденные", fr: "assiettes plates", ro: "farfurii", pl: "talerze obiadowe", he: "צלחות ארוחה", es: "platos llanos" },
  soup_plates: { en: "Soup plates", el: "Πιάτα σούπας", it: "piatti fondi", de: "Suppenteller", ru: "тарелки суповые", fr: "assiettes creuses", ro: "farfurii adânci", pl: "talerze głębokie", he: "צלחות מרק", es: "platos hondos" },
  glasses_water: { en: "Glasses of water", el: "Ποτήρια νερού", it: "bicchieri d'acqua", de: "Wassergläser", ru: "стаканы для воды", fr: "verres à eau", ro: "pahare de apă", pl: "szklanki do wody", he: "כוסות מים", es: "vasos de agua" },
  glasses_wine: { en: "Glasses of wine", el: "Ποτήρια κρασιού" },
  knives: { en: "Knives", el: "Μαχαίρια" },
  forks: { en: "Forks", el: "Πιρούνια", it: "forchette", de: "Gabeln", ru: "вилки", fr: "fourchettes", ro: "furculițe", pl: "widelce", he: "מזלגות", es: "tenedores" },
  spoons: { en: "Spoons", el: "Κουτάλια", it: "cucchiai", de: "Löffel", ru: "ложки", fr: "cuillères", ro: "linguri", pl: "łyżki", he: "כפות", es: "cucharas" },
  gps_plotter: { en: "GPS - Plotter", el: "GPS - Πλότερ", it: "GPS - Plotter", de: "GPS - Plotter", ru: "GPS - Плоттер", fr: "GPS - Traceur", ro: "GPS - Plotter", pl: "GPS - Ploter", he: "GPS - פלוטר", es: "GPS - Plotter" },
  vhf_dsc: { en: "VHF/DSC", el: "VHF/DSC", it: "VHF/DSC", de: "VHF/DSC", ru: "VHF/DSC", fr: "VHF/DSC", ro: "VHF/DSC", pl: "VHF/DSC", he: "VHF/DSC", es: "VHF/DSC" },
  binoculars: { en: "Binoculars", el: "Κιάλια", it: "binocolo", de: "Fernglas", ru: "бинокль", fr: "jumelles", ro: "binoclu", pl: "lornetka", he: "משקפת", es: "prismáticos" },
  charts: { en: "Charts", el: "Ναυτικοί χάρτες", it: "carte nautiche", de: "Seekarten", ru: "морские карты", fr: "cartes marines", ro: "hărți nautice", pl: "mapy morskie", he: "מפות ימיות", es: "cartas náuticas" },
  life_raft: { en: "Life raft", el: "Σωσίβια λέμβος", it: "zattera di salvataggio", de: "Rettungsinsel", ru: "спасательный плот", fr: "radeau de sauvetage", ro: "plută de salvare", pl: "tratwa ratunkowa", he: "רפסודת הצלה", es: "balsa salvavidas" },
  life_jackets: { en: "Life jackets", el: "Σωσίβια", it: "giubbotti di salvataggio", de: "Rettungswesten", ru: "спасательные жилеты", fr: "gilets de sauvetage", ro: "veste de salvare", pl: "kamizelki ratunkowe", he: "אפודי הצלה", es: "chalecos salvavidas" },
  flares: { en: "Flares", el: "Φωτοβολίδες", it: "razzi di segnalazione", de: "Signalraketen", ru: "сигнальные ракеты", fr: "fusées de détresse", ro: "rachete de semnalizare", pl: "race sygnalizacyjne", he: "אבוקות מצוקה", es: "bengalas" },
  first_aid_kit: { en: "First aid kit", el: "Φαρμακείο", it: "kit pronto soccorso", de: "Erste-Hilfe-Set", ru: "аптечка", fr: "trousse de secours", ro: "trusă de prim ajutor", pl: "apteczka", he: "ערכת עזרה ראשונה", es: "botiquín" },
  generator: { en: "Generator", el: "Γεννήτρια", it: "generatore", de: "Generator", ru: "генератор", fr: "générateur", ro: "generator", pl: "generator", he: "גנרטור", es: "generador" },
  spare_anchor: { en: "Spare anchor", el: "Εφεδρική άγκυρα", it: "ancora di rispetto", de: "Reserveanker", ru: "запасной якорь", fr: "ancre de rechange", ro: "ancoră de rezervă", pl: "kotwica zapasowa", he: "עוגן חלופי", es: "ancla de repuesto" },
  deck_brush: { en: "Deck brush", el: "Βούρτσα καταστρώματος", it: "spazzola ponte", de: "Deckbürste", ru: "щётка для палубы", fr: "brosse de pont", ro: "perie de punte", pl: "szczotka pokładowa", he: "מברשת סיפון", es: "cepillo de cubierta" },
  gangway: { en: "Gangway", el: "Πασαρέλα", it: "passerella", de: "Gangway", ru: "трап", fr: "passerelle", ro: "pasarelă", pl: "trap", he: "גשר כניסה", es: "pasarela" },
  lines_20m: { en: "Lines 20m", el: "Σχοινιά 20m", it: "cime 20m", de: "Leinen 20m", ru: "лини 20м", fr: "amarres 20m", ro: "parâme 20m", pl: "liny 20m", he: "חבלים 20מ", es: "cabos 20m" },
  lines_50m: { en: "Lines 50m", el: "Σχοινιά 50m", it: "cime 50m", de: "Leinen 50m", ru: "лини 50м", fr: "amarres 50m", ro: "parâme 50m", pl: "liny 50m", he: "חבלים 50מ", es: "cabos 50m" },
  inflatable_dinghy: { en: "Inflatable dinghy", el: "Φουσκωτή βάρκα", it: "gommone gonfiabile", de: "Schlauchboot", ru: "надувная лодка", fr: "annexe gonflable", ro: "barcă gonflabilă", pl: "ponton dmuchany", he: "סירה מתנפחת", es: "bote inflable" },
  oars: { en: "Oars", el: "Κουπιά", it: "remi", de: "Ruder", ru: "вёсла", fr: "rames", ro: "vâsle", pl: "wiosła", he: "משוטים", es: "remos" },
  air_pump: { en: "Air pump", el: "Αντλία αέρα", it: "pompa aria", de: "Luftpumpe", ru: "воздушный насос", fr: "pompe à air", ro: "pompă de aer", pl: "pompka powietrza", he: "משאבת אוויר", es: "bomba de aire" },
  bow_fenders: { en: "Bow fenders", el: "Μπαλόνια πλαϊνά", it: "parabordi prua", de: "Bug-Fender", ru: "носовые кранцы", fr: "pare-battages avant", ro: "apărători prova", pl: "odbijacze dziobowe", he: "פנדרים קידמיים", es: "defensas de proa" },
  stern_fenders: { en: "Stern fenders", el: "Μπαλόνια πρύμνης", it: "parabordi poppa", de: "Heck-Fender", ru: "кормовые кранцы", fr: "pare-battages arrière", ro: "apărători pupa", pl: "odbijacze rufowe", he: "פנדרים אחוריים", es: "defensas de popa" },
  telescopic_boathook: { en: "Telescopic boat-hook", el: "Τηλεσκοπικός γάντζος", it: "mezzo marinaio telescopico", de: "Teleskop-Bootshaken", ru: "телескопический отпорный крюк", fr: "gaffe télescopique", ro: "cange telescopică", pl: "bosak teleskopowy", he: "אנקול טלסקופי", es: "bichero telescópico" }
};

function getLabel(key, lang) {
  return ITEM_LABELS[key]?.[lang] || ITEM_LABELS[key]?.['en'] || key;
}

// MASTER MERGE: render list = master_items keys + saved values per booking.
// Stale saved keys (no longer in master_items) are dropped. Missing keys get defaults.
const mergeWithMaster = (savedItems, masterKeys, defaults = {}) => {
  if (!masterKeys || masterKeys.length === 0) return savedItems || [];
  const byKey = new Map((savedItems || []).map(it => [it.key || it.id, it]));
  return masterKeys.map(key => {
    const saved = byKey.get(key);
    if (saved) return { ...saved, key, id: saved.id || key };
    const def = defaults[key] || {};
    return {
      id: key, key,
      price: def.price != null ? String(def.price) : "0.00",
      qty: def.qty != null ? Number(def.qty) : 1,
      inOk: false, out: null, media: []
    };
  });
};

const VESSELS = [
  { id: 'lagoon-42-bob', name: 'Lagoon 42-BOB', category: 'catamaran' },
  { id: 'lagoon-46-perla', name: 'Lagoon 46-PERLA', category: 'catamaran' },
  { id: 'bali-42-infinity', name: 'Bali 4.2-INFINITY', category: 'catamaran' },
  { id: 'jeanneau-so-449-maria1', name: 'Jeanneau Sun Odyssey 449-MARIA1', category: 'monohull' },
  { id: 'jeanneau-yacht-54-maria2', name: 'Jeanneau yacht 54-MARIA2', category: 'monohull' },
  { id: 'beneteau-oceanis-46-1-bar-bar', name: 'Beneteau Oceanis 46.1-BAR-BAR', category: 'monohull' },
  { id: 'bavaria-c42-kalispera', name: 'Bavaria c42 Cruiser-KALISPERA', category: 'monohull' },
  { id: 'bavaria-c42-valesia', name: 'Bavaria c42 Cruiser-VALESIA', category: 'monohull' }
];

// Floorplan images - using relative path for all environments
// Images must be uploaded to: /var/www/html/images/floorplans/ on the server
const IMAGE_BASE_URL = '/images/floorplans';

const VESSEL_FLOORPLANS: Record<string, string> = {
  'bob': `${IMAGE_BASE_URL}/lagoon-42.webp`,
  'perla': `${IMAGE_BASE_URL}/lagoon-46.png`,
  'infinity': `${IMAGE_BASE_URL}/bali-4-2-infinity.png`,
  'maria 1': `${IMAGE_BASE_URL}/jeanneau-449.png`,
  'maria 2': `${IMAGE_BASE_URL}/jeanneau-54.png`,
  'bar bar': `${IMAGE_BASE_URL}/beneteau-oceanis-46-new.png`,
  'kalispera': `${IMAGE_BASE_URL}/bavaria-c42-cruiser-kalispera.png`,
  'valesia': `${IMAGE_BASE_URL}/bavaria-c42-cruiser-valesia.png`
};

// Map various vessel name formats to simple lowercase names
const VESSEL_NAME_ALIASES: Record<string, string> = {
  'bob': 'bob',
  'lagoon-42-bob': 'bob',
  'lagoon 42': 'bob',
  'perla': 'perla',
  'lagoon-46-perla': 'perla',
  'lagoon 46': 'perla',
  'infinity': 'infinity',
  'bali-42-infinity': 'infinity',
  'bali 4.2': 'infinity',
  'maria1': 'maria 1',
  'maria 1': 'maria 1',
  'jeanneau-so-449-maria1': 'maria 1',
  'maria2': 'maria 2',
  'maria 2': 'maria 2',
  'jeanneau-yacht-54-maria2': 'maria 2',
  'bar-bar': 'bar bar',
  'bar bar': 'bar bar',
  'barbar': 'bar bar',
  'beneteau-oceanis-46-1-bar-bar': 'bar bar',
  'kalispera': 'kalispera',
  'bavaria-c42-kalispera': 'kalispera',
  'valesia': 'valesia',
  'bavaria-c42-valesia': 'valesia'
};

// Map vessel keys to API vessel IDs for floorplan loading
const VESSEL_NAME_TO_ID: Record<string, number> = {
  'bob': 8,
  'perla': 7,
  'infinity': 6,
  'maria 1': 1,
  'maria 2': 2,
  'bar bar': 4,
  'kalispera': 5,
  'valesia': 3
};

const VESSEL_HOTSPOTS = {
  'bob': [
    { id: "hs_kitchen", x: 0.4535, y: 0.5945, title: "KITCHEN", category: "items" },
    { id: "hs_nav", x: 0.5421, y: 0.6283, title: "NAVIGATION", category: "navItems" },
    { id: "hs_safety", x: 0.5491, y: 0.5582, title: "SAFETY", category: "safetyItems" },
    { id: "hs_gen", x: 0.7360, y: 0.4005, title: "GENERATOR", category: "genItems" },
    { id: "hs_deck", x: 0.2465, y: 0.4043, title: "DECK", category: "deckItems" },
    { id: "hs_fdeck", x: 0.7421, y: 0.5957, title: "FRONT DECK", category: "fdeckItems" },
    { id: "hs_dinghy", x: 0.1175, y: 0.4884, title: "DINGHY", category: "dinghyItems" },
    { id: "hs_fenders", x: 0.4702, y: 0.1176, title: "FENDERS", category: "fendersItems" },
    { id: "hs_boathook", x: 0.3070, y: 0.2466, title: "BOAT-HOOK", category: "boathookItems" }
  ],
  'perla': [
    { id: "hs_kitchen", x: 0.4338, y: 0.4225, title: "KITCHEN", category: "items" },
    { id: "hs_nav", x: 0.5359, y: 0.4063, title: "NAVIGATION", category: "navItems" },
    { id: "hs_safety", x: 0.5277, y: 0.5828, title: "SAFETY", category: "safetyItems" },
    { id: "hs_gen", x: 0.6808, y: 0.4553, title: "GENERATOR", category: "genItems" },
    { id: "hs_deck", x: 0.2511, y: 0.5886, title: "DECK", category: "deckItems" },
    { id: "hs_fdeck", x: 0.6778, y: 0.5577, title: "FRONT DECK", category: "fdeckItems" },
    { id: "hs_dinghy", x: 0.1745, y: 0.4901, title: "DINGHY", category: "dinghyItems" },
    { id: "hs_fenders", x: 0.4410, y: 0.0672, title: "FENDERS", category: "fendersItems" },
    { id: "hs_boathook", x: 0.2889, y: 0.2035, title: "BOAT-HOOK", category: "boathookItems" }
  ],
  'infinity': [
    { id: "hs_kitchen", x: 0.5553, y: 0.5426, title: "KITCHEN", category: "items" },
    { id: "hs_nav", x: 0.5650, y: 0.6989, title: "NAVIGATION", category: "navItems" },
    { id: "hs_safety", x: 0.3629, y: 0.6930, title: "SAFETY", category: "safetyItems" },
    { id: "hs_gen", x: 0.7156, y: 0.6794, title: "GENERATOR", category: "genItems" },
    { id: "hs_deck", x: 0.2865, y: 0.6012, title: "DECK", category: "deckItems" },
    { id: "hs_fdeck", x: 0.7231, y: 0.5524, title: "FRONT DECK", category: "fdeckItems" },
    { id: "hs_dinghy", x: 0.1435, y: 0.5876, title: "DINGHY", category: "dinghyItems" },
    { id: "hs_fenders", x: 0.4779, y: 0.2438, title: "FENDERS", category: "fendersItems" },
    { id: "hs_boathook", x: 0.4123, y: 0.3063, title: "BOAT-HOOK", category: "boathookItems" }
  ],
  'maria 1': [
    { id: "hs_kitchen", x: 0.3718, y: 0.8627, title: "KITCHEN", category: "items" },
    { id: "hs_nav", x: 0.4760, y: 0.7257, title: "NAVIGATION", category: "navItems" },
    { id: "hs_safety", x: 0.5343, y: 0.8412, title: "SAFETY", category: "safetyItems" },
    { id: "hs_deck", x: 0.1864, y: 0.1512, title: "DECK", category: "deckItems" },
    { id: "hs_fdeck", x: 0.1822, y: 0.3096, title: "FRONT DECK", category: "fdeckItems" },
    { id: "hs_dinghy", x: 0.5968, y: 0.2344, title: "DINGHY", category: "dinghyItems" },
    { id: "hs_fenders", x: 0.4447, y: 0.4036, title: "FENDERS", category: "fendersItems" },
    { id: "hs_boathook", x: 0.3926, y: 0.2398, title: "BOAT-HOOK", category: "boathookItems" }
  ],
  'maria 2': [
    { id: "hs_kitchen", x: 0.511393, y: 0.285991, title: "KITCHEN", category: "items" },
    { id: "hs_nav", x: 0.40931, y: 0.429192, title: "NAVIGATION", category: "navItems" },
    { id: "hs_safety", x: 0.53431, y: 0.403785, title: "SAFETY", category: "safetyItems" },
    { id: "hs_gen", x: 0.208238, y: 0.83468, title: "GENERATOR", category: "genItems" },
    { id: "hs_deck", x: 0.224905, y: 0.867015, title: "DECK", category: "deckItems" },
    { id: "hs_fdeck", x: 0.210321, y: 0.749221, title: "FRONT DECK", category: "fdeckItems" },
    { id: "hs_dinghy", x: 0.648893, y: 0.840315, title: "DINGHY", category: "dinghyItems" },
    { id: "hs_fenders", x: 0.45306, y: 0.66016, title: "FENDERS", category: "fendersItems" },
    { id: "hs_boathook", x: 0.387405, y: 0.813892, title: "BOAT-HOOK", category: "boathookItems" }
  ],
  'bar bar': [
    { id: "hs_kitchen", x: 0.4500, y: 0.5990, title: "KITCHEN", category: "items" },
    { id: "hs_nav", x: 0.3786, y: 0.8444, title: "NAVIGATION", category: "navItems" },
    { id: "hs_safety", x: 0.5025, y: 0.7677, title: "SAFETY", category: "safetyItems" },
    { id: "hs_gen", x: 0.1200, y: 0.2300, title: "GENERATOR", category: "genItems" },
    { id: "hs_deck", x: 0.2100, y: 0.1400, title: "DECK", category: "deckItems" },
    { id: "hs_fdeck", x: 0.2100, y: 0.3500, title: "FRONT DECK", category: "fdeckItems" },
    { id: "hs_dinghy", x: 0.5500, y: 0.2500, title: "DINGHY", category: "dinghyItems" },
    { id: "hs_fenders", x: 0.3500, y: 0.0156, title: "FENDERS", category: "fendersItems" },
    { id: "hs_boathook", x: 0.3700, y: 0.2400, title: "BOAT-HOOK", category: "boathookItems" }
  ],
  'kalispera': [
    { id: "hs_kitchen", x: 0.3788, y: 0.5919, title: "KITCHEN", category: "items" },
    { id: "hs_nav", x: 0.4337, y: 0.6070, title: "NAVIGATION", category: "navItems" },
    { id: "hs_safety", x: 0.4870, y: 0.7080, title: "SAFETY", category: "safetyItems" },
    { id: "hs_deck", x: 0.2568, y: 0.1776, title: "DECK", category: "deckItems" },
    { id: "hs_fdeck", x: 0.2583, y: 0.2989, title: "FRONT DECK", category: "fdeckItems" },
    { id: "hs_dinghy", x: 0.5602, y: 0.2458, title: "DINGHY", category: "dinghyItems" },
    { id: "hs_fenders", x: 0.4062, y: 0.0715, title: "FENDERS", category: "fendersItems" },
    { id: "hs_boathook", x: 0.3361, y: 0.2534, title: "BOAT-HOOK", category: "boathookItems" }
  ],
  'valesia': [
    { id: "hs_kitchen", x: 0.3879, y: 0.6020, title: "KITCHEN", category: "items" },
    { id: "hs_nav", x: 0.4489, y: 0.6247, title: "NAVIGATION", category: "navItems" },
    { id: "hs_safety", x: 0.4977, y: 0.7131, title: "SAFETY", category: "safetyItems" },
    { id: "hs_deck", x: 0.2553, y: 0.1776, title: "DECK", category: "deckItems" },
    { id: "hs_fdeck", x: 0.2507, y: 0.2888, title: "FRONT DECK", category: "fdeckItems" },
    { id: "hs_dinghy", x: 0.5434, y: 0.2382, title: "DINGHY", category: "dinghyItems" },
    { id: "hs_fenders", x: 0.4108, y: 0.0690, title: "FENDERS", category: "fendersItems" },
    { id: "hs_boathook", x: 0.4047, y: 0.2458, title: "BOAT-HOOK", category: "boathookItems" }
  ]
};

const getHotspotsForVesselFallback = (vesselId) => {
  return VESSEL_HOTSPOTS[vesselId] || [];
};

export default function Page4({ onNavigate }: { onNavigate?: (direction: string) => void }) {
  // 🔥 FIX: Use location to detect when page is navigated to
  const location = useLocation();
  const navigate = useNavigate();

  const [lang, setLang] = useState(sessionStorage.getItem("yacht_lang") || "en");
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [mode, setMode] = useState("in");
  const [currentBookingNumber, setCurrentBookingNumber] = useState("");
  const [bookingInfo, setBookingInfo] = useState(null);
  const [isEmployee, setIsEmployee] = useState(false);
  const [currentEmployee, setCurrentEmployee] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [employeeCode, setEmployeeCode] = useState("");
  const [showEmployeeCode, setShowEmployeeCode] = useState(false);

  // 🔥 Read logged-in user (from Gate Page) on mount so role-gated sections appear without re-login
  useEffect(() => {
    let u: any = null;
    try { u = JSON.parse(sessionStorage.getItem('auth_current_user') || 'null'); } catch (e) { u = null; }
    if (!u) u = authService.getCurrentUser();
    if (u) {
      setIsEmployee(true);
      setCurrentEmployee({ ...(u.permissions || {}), role: u.role });
    }
  }, []);

  const [items, setItems] = useState([]);
  const [navItems, setNavItems] = useState([]);
  const [safetyItems, setSafetyItems] = useState([]);
  const [genItems, setGenItems] = useState([]);
  const [deckItems, setDeckItems] = useState([]);
  const [fdeckItems, setFdeckItems] = useState([]);
  const [dinghyItems, setDinghyItems] = useState([]);
  const [fendersItems, setFendersItems] = useState([]);
  const [boathookItems, setBoathookItems] = useState([]);

  // 🔒 SNAPSHOT freeze (page4 parity): once page5_agreement.items_snapshot.page2
  // contains items for this (booking, mode), all TableSections become read-only.
  // Detection only — live data remains source of truth.
  const [isFrozen, setIsFrozen] = useState(false);

  const [sectionKeys, setSectionKeys] = useState({
    kitchen: [], navigation: [], safety_floorplan: [],
    generator_floorplan: [], deck: [], fdeck: [],
    dinghy_floorplan: [], fenders: [], boathook: []
  });
  const [keysLoaded, setKeysLoaded] = useState(false);
  // Stage 5β: Dynamic section state (non-legacy, DB-driven)
  const [masterSections, setMasterSections] = useState<any[]>([]);
  const [dynamicSectionData, setDynamicSectionData] = useState<Record<string, any[]>>({});
  const [dynamicSectionTitles, setDynamicSectionTitles] = useState<Record<string, string>>({});
  const [dynamicLoaderReady, setDynamicLoaderReady] = useState(false);
  const [masterDefaultsReady, setMasterDefaultsReady] = useState(false);
  const [masterDefaults, setMasterDefaults] = useState({
    kitchen: {}, navigation: {}, safety_floorplan: {},
    generator_floorplan: {}, deck: {}, fdeck: {},
    dinghy_floorplan: {}, fenders: {}, boathook: {}
  });

  const [notes, setNotes] = useState("");
  const [signatureImage, setSignatureImage] = useState("");
  
  const [newKitchenItem, setNewKitchenItem] = useState("");
  const [newNavItem, setNewNavItem] = useState("");
  const [newSafetyItem, setNewSafetyItem] = useState("");
  const [newGenItem, setNewGenItem] = useState("");
  const [newDeckItem, setNewDeckItem] = useState("");
  const [newFdeckItem, setNewFdeckItem] = useState("");
  const [newDinghyItem, setNewDinghyItem] = useState("");
  const [newFendersItem, setNewFendersItem] = useState("");
  const [newBoathookItem, setNewBoathookItem] = useState("");
  
  const [showCamera, setShowCamera] = useState(false);
  const [currentItemId, setCurrentItemId] = useState(null);
  const [pendingFlashItemId, setPendingFlashItemId] = useState(null);
  const [zoomUrl, setZoomUrl] = useState(null);
  
  const [selectedVessel, setSelectedVessel] = useState('');
  const [activeSection, setActiveSection] = useState(null);
  const [hoveredHotspot, setHoveredHotspot] = useState(null);
  const [imageError, setImageError] = useState(false);
  const [apiFloorplan, setApiFloorplan] = useState<{ background_image: string; hotspots: any[] } | null>(null);
  const [loadingFloorplan, setLoadingFloorplan] = useState(false);

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const fileInputRef = useRef(null);

  // 🔥 Detect booking change WITHOUT localStorage (App.tsx writes localStorage before we see context)
  const prevBookingRef = useRef(null);
  
  const t = I18N[lang];

  // 🟡 CHECK-IN PREVIEW — σήμερα < ημέρα check-in ΚΑΙ mode='in' → τα save γίνονται no-op.
  // Ξανα-υπολογίζεται όποτε αλλάξουν ημερομηνίες/mode (και μετά από reload απευθείας
  // στη σελίδα 2, αφού το bookingInfo έρχεται από page1.php/bookings.php).
  useEffect(() => {
    syncCheckinPreview(bookingInfo?.checkInDate, bookingInfo?.checkOutDate, mode);
  }, [bookingInfo?.checkInDate, bookingInfo?.checkOutDate, mode]);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    if (pendingFlashItemId && activeSection) {
      console.log('🎯 useEffect triggered! Looking for item:', pendingFlashItemId);
      
      setTimeout(() => {
        const row = document.querySelector(`[data-item-id="${pendingFlashItemId}"]`);
        console.log('📍 Found row in useEffect:', row);
        
        if (row) {
          row.scrollIntoView({ behavior: 'smooth', block: 'center' });
          row.style.backgroundColor = '#fee2e2';
          setTimeout(() => {
            row.style.backgroundColor = '';
          }, 3000);
        } else {
          console.error('❌ Row still not found! Item ID:', pendingFlashItemId);
        }
        
        setPendingFlashItemId(null);
      }, 100);
    }
  }, [pendingFlashItemId, activeSection]);

  // Get context data
  const contextData = useContext(DataContext);

  // 🔒 SNAPSHOT detection useEffect (see isFrozen above)
  useEffect(() => {
    const bn = contextData?.bookingNumber || (typeof window !== 'undefined' ? localStorage.getItem('currentBooking') : null);
    const m = (contextData?.mode || 'in') as 'in' | 'out';
    if (!bn) { setIsFrozen(false); return; }
    let cancelled = false;
    (async () => {
      try {
        const ag = await getPage5Agreement(bn);
        if (cancelled) return;
        const row = m === 'in' ? ag?.checkIn : ag?.checkOut;
        const snap = row?.items_snapshot?.page2;
        const hasItems = snap && typeof snap === 'object' &&
          Object.values(snap).some((arr: any) => Array.isArray(arr) && arr.length > 0);
        let coDate = '';
        let coTime = '';
        try {
          const p1 = await getPage1DataHybrid(bn);
          coDate = (p1 as any)?.checkOutDate || '';
          coTime = (p1 as any)?.checkOutTime || '';
        } catch (eP1) { coDate = ''; coTime = ''; }
        const submittedP2 = !!hasItems && row?.email_sent === true;
        // FAIL-SAFE: if we don't know checkout date -> keep old behavior (freeze). If known -> freeze only after end+1h (Athens).
        setIsFrozen(submittedP2 && (!coDate || isPastCheckoutGrace(coDate, coTime, 1)));
      } catch (e) {
        console.warn('Page 2 snapshot check failed (treating as not frozen):', e);
        if (!cancelled) setIsFrozen(false);
      }
    })();
    return () => { cancelled = true; };
  }, [contextData?.bookingNumber, contextData?.mode]);

  useEffect(() => {
    const loadBookingFromAPI = async () => {
      // Use currentBooking from context or localStorage (UI state)
      const currentBooking = contextData?.bookingNumber || localStorage.getItem('currentBooking');

      if (currentBooking) {
        try {
          // 🔥 FIX: First get vessel from Page 1 API (where it's actually saved)
          const page1Data = await getPage1DataHybrid(currentBooking);
          console.log('📍 Page 1 data loaded:', page1Data);

          // Also fetch booking info from bookings API for other data
          const allBookings = await getAllBookings();
          const booking = allBookings.find((b: any) =>
            b.bookingNumber === currentBooking || b.code === currentBooking
          );

          if (booking || page1Data) {
            setCurrentBookingNumber(currentBooking);

            // 🔥 FIX: Merge booking info, prioritizing Page 1 data (source of truth for vessel/skipper/dates)
            const mergedBookingInfo = {
              ...booking,
              // Override with Page 1 data (where the actual form data is saved)
              vesselName: page1Data?.vesselName || booking?.vesselName || booking?.vessel,
              skipperFirstName: page1Data?.skipperFirstName || booking?.skipperFirstName,
              skipperLastName: page1Data?.skipperLastName || booking?.skipperLastName,
              checkInDate: page1Data?.checkInDate || booking?.checkInDate,
              checkOutDate: page1Data?.checkOutDate || booking?.checkOutDate,
              checkInTime: page1Data?.checkInTime || booking?.checkInTime,
              checkOutTime: page1Data?.checkOutTime || booking?.checkOutTime,
            };
            setBookingInfo(mergedBookingInfo);
            console.log('📍 Merged booking info:', mergedBookingInfo);

            const savedMode = contextData?.mode || booking?.mode || page1Data?.mode || 'in';
            setMode(savedMode);

            // 🔥 FIX: Get vessel name from Page 1 data FIRST (source of truth), then fallback to booking
            const rawVesselName = mergedBookingInfo.vesselName || '';
            console.log('📍 Raw vessel name from Page 1:', rawVesselName);

        if (rawVesselName) {
          const vesselLower = rawVesselName.toLowerCase();
          let vesselKey: string | null = null;

          // Step 1: Try direct match in aliases
          if (VESSEL_NAME_ALIASES[vesselLower]) {
            vesselKey = VESSEL_NAME_ALIASES[vesselLower];
            console.log('📍 Direct alias match:', vesselLower, '→', vesselKey);
          }

          // Step 2: Try partial match by boat nickname
          if (!vesselKey) {
            for (const [alias, key] of Object.entries(VESSEL_NAME_ALIASES)) {
              if (vesselLower.includes(alias)) {
                vesselKey = key;
                console.log('📍 Partial match:', alias, '→', vesselKey);
                break;
              }
            }
          }

          // Step 3: Fallback to default
          if (!vesselKey) {
            console.warn('⚠️ No floorplan found for vessel:', rawVesselName, '- using default');
            vesselKey = 'bob';
          }

          console.log('📍 Final vessel key:', vesselKey);
          console.log('📍 Floorplan URL:', VESSEL_FLOORPLANS[vesselKey]);
            setSelectedVessel(vesselKey);
          }

          loadDataForMode(currentBooking, savedMode);

          console.log(`✅ Page 4 loaded from API: ${currentBooking}, Mode: ${savedMode}, Vessel: ${rawVesselName}`);
          } else {
            console.warn(`⚠️ Booking ${currentBooking} not found in API`);
          }
        } catch (error) {
          console.error('❌ Error loading booking from API:', error);
        }
      }
    };

    loadBookingFromAPI();
  }, [contextData?.bookingNumber, contextData?.mode, location.key]);  // 🔥 FIX: Added location.key to re-run when page is navigated to

  // 🔥 Reset data if booking number changed (useRef-based — no localStorage; multi-tenant safe)
  useEffect(() => {
    const bn = contextData?.bookingNumber || '';
    if (!bn) return;
    if (prevBookingRef.current !== null && prevBookingRef.current !== bn) {
      console.log(`🔄 Page2 booking changed: ${prevBookingRef.current} → ${bn} - RESETTING all data`);
      setItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setNavItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setSafetyItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setGenItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setDeckItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setFdeckItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setDinghyItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setFendersItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setBoathookItems(prev => prev.map(it => ({ ...it, inOk: false, out: null, media: [] })));
      setNotes("");
      setSignatureImage("");
    }
    prevBookingRef.current = bn;
  }, [contextData?.bookingNumber]);

  // Load canonical key list per section + labels from master_items (page_group='page2'), one-time on mount.
  // Mutates module-level ITEM_LABELS so existing getLabel() resolves moved-in keys without JSX changes.
  useEffect(() => {
    (async () => {
      try {
        const masterItems = await getMasterItems(undefined, 'page2');
        const grouped = {
          kitchen: [], navigation: [], safety_floorplan: [],
          generator_floorplan: [], deck: [], fdeck: [],
          dinghy_floorplan: [], fenders: [], boathook: []
        };
        const defaultsAcc = {
          kitchen: {}, navigation: {}, safety_floorplan: {},
          generator_floorplan: {}, deck: {}, fdeck: {},
          dinghy_floorplan: {}, fenders: {}, boathook: {}
        };
        const langCodes = ['el','en','it','de','ru','fr','ro','pl','he','es'];
        for (const mi of (masterItems || [])) {
          if (mi.active === false) continue;
          if (grouped[mi.section]) grouped[mi.section].push(mi.item_key);
          if (defaultsAcc[mi.section]) {
            const entry = {};
            for (const lc of langCodes) {
              const col = 'label_' + lc;
              if (mi[col] != null) entry[col] = mi[col];
            }
            defaultsAcc[mi.section][mi.item_key] = entry;
          }
          // Mutate module-level ITEM_LABELS so existing getLabel() resolves moved-in keys.
          if (!ITEM_LABELS[mi.item_key]) ITEM_LABELS[mi.item_key] = {};
          for (const lc of langCodes) {
            const col = 'label_' + lc;
            if (mi[col] != null) ITEM_LABELS[mi.item_key][lc] = mi[col];
          }
        }
        setSectionKeys(grouped);
        setMasterDefaults(defaultsAcc);
        console.log('Dynamic Page 2: master_items loaded', grouped);
      } catch (err) {
        console.error('Dynamic Page 2: master_items load failed', err);
      } finally {
        setKeysLoaded(true);
      }
    })();
  }, []);

  // Stage 5β: Load master_sections + non-legacy section items from DB
  useEffect(() => {
    (async () => {
      try {
        const secs = await getMasterSections('page2');
        setMasterSections(secs || []);
        // Φόρτωση titles για ΟΛΑ τα sections (legacy + dynamic) — items μόνο για dynamic
        const allTitles: Record<string, string> = {};
        for (const s of (secs || [])) {
          if (s && s.section_key && s.active !== false) {
            allTitles[s.section_key] = s['title_' + lang] || s.title_el || s.section_key;
          }
        }
        // 🔥 FIX: set legacy titles ΠΡΙΝ από το early return για να ισχύουν πάντα
        setDynamicSectionTitles(prev => ({ ...prev, ...allTitles }));
        const dyn = (secs || []).filter((s: any) => s && s.section_key && !isLegacyCategory(s.section_key) && s.active !== false);
        if (!dyn.length) return;
        const vesselId = VESSEL_NAME_TO_ID[selectedVessel];
        const newData: Record<string, any[]> = {};
        const newTitles: Record<string, string> = {};
        for (const sec of dyn) {
          const sk = sec.section_key;
          try {
            const [mItems, yItems] = await Promise.all([
              getMasterItems(sk, 'page2'),
              vesselId ? getYachtItems(vesselId, sk) : Promise.resolve([])
            ]);
            const yByKey = new Map(
              (yItems || []).filter((yi: any) => yi.active !== false).map((yi: any) => [yi.item_key, yi])
            );
            newData[sk] = (mItems || [])
              .filter((mi: any) => mi.active !== false)
              .map((mi: any) => {
                const yi = yByKey.get(mi.item_key);
                if (!yi) return null;
                return {
                  id: uid(), key: mi.item_key,
                  price: yi.price != null ? String(yi.price) : "",
                  qty: yi.qty != null ? Number(yi.qty) : 1,
                  inOk: false, out: null, media: []
                };
              })
              .filter(Boolean);
            newTitles[sk] = sec['title_' + lang] || sec.title_el || sk;
          } catch (e) { console.error('[stage5b] items load failed', sk, e); }
        }
        // v6.92: merge guard — διατήρησε user changes (inOk/out/media) αν υπάρχει ήδη state
        setDynamicSectionData(prev => {
          const merged: Record<string, any[]> = {};
          Object.keys(newData).forEach(sk => {
            const existing = prev[sk];
            if (existing && existing.length > 0) {
              merged[sk] = newData[sk].map(ni => {
                const ex = existing.find((e: any) => e.key === ni.key);
                return ex ? { ...ni, inOk: ex.inOk, out: ex.out, media: ex.media } : ni;
              });
            } else {
              merged[sk] = newData[sk];
            }
          });
          return merged;
        });
        // Merge: dynamic items titles + legacy section titles (όλα από DB)
        setDynamicSectionTitles({ ...allTitles, ...newTitles });
        setDynamicLoaderReady(true);   // 🔥 RACE FIX: σήμα ότι dynamic γέμισε
      } catch (err) {
        console.error('[stage5b] master_sections load failed', err);
      }
    })();
  }, [lang, selectedVessel]);

  // 🔥 RACE FIX: master_items load is async; if a booking was already loaded
  // before sectionKeys/masterDefaults arrived, loadDataForMode ran mergeWithMaster
  // with empty keys (→ no items). Re-run loadDataForMode once keys are ready.
  // Fires ONCE only (keysLoaded never reverts to false).
  useEffect(() => {
    if (keysLoaded && currentBookingNumber) {
      loadDataForMode(currentBookingNumber, contextData?.mode || 'in');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keysLoaded]);

  // 🔥 RACE FIX (dynamic): Stage 5β loader is async; on return navigation (2nd mount)
  // loadDataForMode can run before dynamicSectionData is filled → saved inOk for
  // cabin/dynamic sections lost. Re-run once the dynamic loader signals ready.
  useEffect(() => {
    if (dynamicLoaderReady && currentBookingNumber) {
      loadDataForMode(currentBookingNumber, contextData?.mode || 'in');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dynamicLoaderReady, selectedVessel]);

  // 🔥 RACE FIX (prices): yacht_items/masterDefaults loads async; loadDataForMode
  // can run with empty masterDefaults → prices 0.00. Re-run once defaults ready.
  useEffect(() => {
    if (masterDefaultsReady && currentBookingNumber) {
      loadDataForMode(currentBookingNumber, contextData?.mode || 'in');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masterDefaultsReady, selectedVessel]);

  // 🔥 PHASE 3: Load items from yacht_items DB per vessel
  useEffect(() => {
    if (!selectedVessel) return;

    const vesselId = VESSEL_NAME_TO_ID[selectedVessel];
    if (!vesselId) return;

    const SECTION_TO_SETTER = {
      kitchen: setItems,
      navigation: setNavItems,
      safety_floorplan: setSafetyItems,
      generator_floorplan: setGenItems,
      deck: setDeckItems,
      fdeck: setFdeckItems,
      dinghy_floorplan: setDinghyItems,
      fenders: setFendersItems,
      boathook: setBoathookItems,
    };

    const SECTION_FALLBACK_KEYS = {
      kitchen: KITCHEN_KEYS,
      navigation: NAV_KEYS,
      safety_floorplan: SAFETY_KEYS,
      generator_floorplan: GEN_KEYS,
      deck: DECK_KEYS,
      fdeck: FDECK_KEYS,
      dinghy_floorplan: DINGHY_KEYS,
      fenders: FENDERS_KEYS,
      boathook: BOATHOOK_KEYS,
    };

    const inlineInit = (keys) => keys.map(key => ({
      id: uid(), key, price: "", qty: 1, inOk: false, out: null, media: []
    }));

    (async () => {
      try {
        // GUARD: Skip yacht_items default load if saved data exists
        const guardMode = contextData?.mode || 'in';
        if (currentBookingNumber) {
          try {
            const savedData = await getPage2DataHybrid(currentBookingNumber, guardMode);
            if (savedData && savedData.items && savedData.items.length > 0) {
              console.log('✋ Phase 3 Page 2: Skipping yacht_items defaults — saved data exists');
              return;
            }
          } catch (e) {
            console.warn('Phase 3 Page 2: guard check failed, proceeding with defaults', e);
          }
        }
        // include_inactive=true: rawGrouped needs to see inactive rows to detect
        // "section is managed but all unchecked" vs "section never seeded".
        const yachtItems = await getYachtItems(vesselId, undefined, true);
        const activeItems = (yachtItems || []).filter(yi => yi.active);

        // Group by section
        const grouped = {};
        // Raw grouping (active+inactive) — distinguishes "section is DB-managed" from "never seeded"
        const rawGrouped = {};
        for (const section of Object.keys(SECTION_TO_SETTER)) {
          grouped[section] = [];
          rawGrouped[section] = [];
        }
        for (const yi of (yachtItems || [])) {
          if (rawGrouped[yi.section]) rawGrouped[yi.section].push(yi);
        }

        for (const yi of activeItems) {
          if (grouped[yi.section]) {
            grouped[yi.section].push({
              id: uid(),
              key: yi.item_key,
              price: yi.price != null ? String(yi.price) : "",
              qty: yi.qty != null ? Number(yi.qty) : 1,
              inOk: false,
              out: null,
              media: []
            });
          }
        }

        // Apply to state. Fallback ONLY when section has zero rows in DB
        // (never seeded). If admin unchecked all items → respect empty list.
        // Also rewrite sectionKeys per-vessel so downstream mergeWithMaster()
        // doesn't reintroduce inactive items from the cross-vessel master_items list.
        const vesselSectionKeys: Record<string, string[]> = {};
        for (const section of Object.keys(SECTION_TO_SETTER)) {
          const setter = SECTION_TO_SETTER[section];
          if (rawGrouped[section].length > 0) {
            setter(grouped[section]);
            vesselSectionKeys[section] = activeItems
              .filter((yi: any) => yi.section === section)
              .map((yi: any) => yi.item_key);
          } else {
            setter(inlineInit(SECTION_FALLBACK_KEYS[section]));
          }
        }
        if (Object.keys(vesselSectionKeys).length > 0) {
          setSectionKeys(prev => ({ ...prev, ...vesselSectionKeys }));
        }

        // Augment masterDefaults with per-vessel price + qty from yacht_items (functional form, no race).
        setMasterDefaults(prev => {
          const next = { ...prev };
          for (const yi of activeItems) {
            if (next[yi.section] && next[yi.section][yi.item_key]) {
              next[yi.section][yi.item_key] = {
                ...next[yi.section][yi.item_key],
                price: yi.price,
                qty: yi.qty
              };
            } else if (next[yi.section]) {
              next[yi.section][yi.item_key] = {
                price: yi.price,
                qty: yi.qty
              };
            }
          }
          return next;
        });

        console.log('🔥 Phase 3: Loaded items from DB for vessel', selectedVessel, 'vessel_id', vesselId);
        setMasterDefaultsReady(true);
      } catch (err) {
        console.warn('⚠️ Phase 3: yacht_items API failed, using hardcoded fallback:', err);
        // FULL FALLBACK: hardcoded for all sections
        setItems(inlineInit(KITCHEN_KEYS));
        setNavItems(inlineInit(NAV_KEYS));
        setSafetyItems(inlineInit(SAFETY_KEYS));
        setGenItems(inlineInit(GEN_KEYS));
        setDeckItems(inlineInit(DECK_KEYS));
        setFdeckItems(inlineInit(FDECK_KEYS));
        setDinghyItems(inlineInit(DINGHY_KEYS));
        setFendersItems(inlineInit(FENDERS_KEYS));
        setBoathookItems(inlineInit(BOATHOOK_KEYS));
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVessel, currentBookingNumber]);
  // 🔥 END PHASE 3

  // Load floorplan from API when vessel changes
  useEffect(() => {
    // 🔥 FIX: Reset API floorplan immediately when vessel changes
    // This ensures the local fallback image is used right away while fetching
    setApiFloorplan(null);
    setImageError(false);

    const loadFloorplanFromAPI = async () => {
      const vesselId = VESSEL_NAME_TO_ID[selectedVessel];
      if (!vesselId) {
        console.log('📍 No vessel ID mapping for:', selectedVessel);
        return;
      }

      setLoadingFloorplan(true);
      try {
        console.log('🔄 Loading floorplan from API for vessel ID:', vesselId, 'vessel:', selectedVessel);
        const floorplan = await getFloorplan(vesselId);

        if (floorplan && floorplan.background_image) {
          console.log('✅ Floorplan loaded from API:', floorplan);
          setApiFloorplan({
            background_image: floorplan.background_image,
            hotspots: floorplan.hotspots || []
          });
          setImageError(false);
        } else {
          console.log('📍 No API floorplan, using local fallback for:', selectedVessel);
          // Keep apiFloorplan as null - local VESSEL_FLOORPLANS will be used
        }
      } catch (error) {
        console.error('❌ Error loading floorplan from API:', error);
        // Keep apiFloorplan as null - local VESSEL_FLOORPLANS will be used
      } finally {
        setLoadingFloorplan(false);
      }
    };

    loadFloorplanFromAPI();
  }, [selectedVessel]);

  const loadDataForMode = async (bookingNumber, selectedMode) => {
    // API only - no localStorage fallback
    let data = null;

    // 🔥 FIX: When in check-out mode, first load check-in data to get inOk values
    let checkInData = null;
    if (selectedMode === 'out') {
      try {
        checkInData = await getPage2DataHybrid(bookingNumber, 'in');
        if (checkInData) {
          console.log('✅ Page 4 check-in data loaded for inOk values');
        }
      } catch (error) {
        console.warn('⚠️ Failed to load check-in data for inOk merge:', error);
      }
    }

    // Helper function to merge inOk from check-in data with current mode data
    const mergeInOkData = (currentItems, checkInItemsData, defaultKeys) => {
      if (!currentItems && !checkInItemsData) return null;

      // If we have current mode items, merge inOk from check-in
      if (currentItems && checkInItemsData) {
        return currentItems.map(item => {
          const checkInItem = checkInItemsData.find(ci => ci.key === item.key);
          return { ...item, inOk: checkInItem?.inOk || item.inOk || false, problematic: checkInItem?.problematic || false };
        });
      }

      // If only check-in items exist (starting checkout), use them as base — preserve inOk for reference
      if (checkInItemsData) {
        return checkInItemsData.map(item => ({ ...item, out: null }));
      }

      return currentItems;
    };

    try {
      const apiData = await getPage2DataHybrid(bookingNumber, selectedMode);
      if (apiData) {
        console.log('✅ Page 4 data loaded from API');
        data = apiData;
      }
    } catch (error) {
      console.error('❌ Error loading Page 4 data from API:', error);
    }

    if (data) {
      // 🔥 FIX: Merge inOk values from check-in when in check-out mode
      const finalItems = selectedMode === 'out'
        ? mergeWithMaster(mergeInOkData(data.items, checkInData?.items, KITCHEN_KEYS) || data.items || [], sectionKeys.kitchen, masterDefaults.kitchen)
        : mergeWithMaster(data.items || [], sectionKeys.kitchen, masterDefaults.kitchen);

      const finalNavItems = selectedMode === 'out'
        ? mergeWithMaster(mergeInOkData(data.navItems, checkInData?.navItems, NAV_KEYS) || data.navItems || [], sectionKeys.navigation, masterDefaults.navigation)
        : mergeWithMaster(data.navItems || [], sectionKeys.navigation, masterDefaults.navigation);

      const finalSafetyItems = selectedMode === 'out'
        ? mergeWithMaster(mergeInOkData(data.safetyItems, checkInData?.safetyItems, SAFETY_KEYS) || data.safetyItems || [], sectionKeys.safety_floorplan, masterDefaults.safety_floorplan)
        : mergeWithMaster(data.safetyItems || [], sectionKeys.safety_floorplan, masterDefaults.safety_floorplan);

      const finalGenItems = selectedMode === 'out'
        ? mergeWithMaster(mergeInOkData(data.genItems, checkInData?.genItems, GEN_KEYS) || data.genItems || [], sectionKeys.generator_floorplan, masterDefaults.generator_floorplan)
        : mergeWithMaster(data.genItems || [], sectionKeys.generator_floorplan, masterDefaults.generator_floorplan);

      const finalDeckItems = selectedMode === 'out'
        ? mergeWithMaster(mergeInOkData(data.deckItems, checkInData?.deckItems, DECK_KEYS) || data.deckItems || [], sectionKeys.deck, masterDefaults.deck)
        : mergeWithMaster(data.deckItems || [], sectionKeys.deck, masterDefaults.deck);

      const finalFdeckItems = selectedMode === 'out'
        ? mergeWithMaster(mergeInOkData(data.fdeckItems, checkInData?.fdeckItems, FDECK_KEYS) || data.fdeckItems || [], sectionKeys.fdeck, masterDefaults.fdeck)
        : mergeWithMaster(data.fdeckItems || [], sectionKeys.fdeck, masterDefaults.fdeck);

      const finalDinghyItems = selectedMode === 'out'
        ? mergeWithMaster(mergeInOkData(data.dinghyItems, checkInData?.dinghyItems, DINGHY_KEYS) || data.dinghyItems || [], sectionKeys.dinghy_floorplan, masterDefaults.dinghy_floorplan)
        : mergeWithMaster(data.dinghyItems || [], sectionKeys.dinghy_floorplan, masterDefaults.dinghy_floorplan);

      const finalFendersItems = selectedMode === 'out'
        ? mergeWithMaster(mergeInOkData(data.fendersItems, checkInData?.fendersItems, FENDERS_KEYS) || data.fendersItems || [], sectionKeys.fenders, masterDefaults.fenders)
        : mergeWithMaster(data.fendersItems || [], sectionKeys.fenders, masterDefaults.fenders);

      const finalBoathookItems = selectedMode === 'out'
        ? mergeWithMaster(mergeInOkData(data.boathookItems, checkInData?.boathookItems, BOATHOOK_KEYS) || data.boathookItems || [], sectionKeys.boathook, masterDefaults.boathook)
        : mergeWithMaster(data.boathookItems || [], sectionKeys.boathook, masterDefaults.boathook);

      setItems(finalItems);
      setNavItems(finalNavItems);
      setSafetyItems(finalSafetyItems);
      setGenItems(finalGenItems);
      setDeckItems(finalDeckItems);
      setFdeckItems(finalFdeckItems);
      setDinghyItems(finalDinghyItems);
      setFendersItems(finalFendersItems);
      setBoathookItems(finalBoathookItems);
      setNotes(data.notes || "");
      setSignatureImage(data.signatureImage || "");
      // Stage 5β: hydrate saved inOk/out/media into dynamic sections from booking data
      setDynamicSectionData(prev => {
        const updated: Record<string, any[]> = {};
        // 🔥 FIX: keys από prev ∪ dynamicSectionTitles (prev μπορεί να είναι {} σε 2ο mount)
        const allDynamicKeys = Array.from(new Set([...Object.keys(prev), ...Object.keys(dynamicSectionTitles)]));
        allDynamicKeys.forEach(sk => {
          const saved = (data as any)?.[sk];
          // 🔥 FIX: αν prev[sk] κενό/undefined (2ο mount) → base = saved (πλήρη persisted items), αλλιώς []
          const base = (prev[sk] && prev[sk].length) ? prev[sk] : (Array.isArray(saved) ? saved : []);
          updated[sk] = Array.isArray(saved)
            ? base.map(it => {
                const sv = saved.find((x: any) => x && x.key === it.key);
                const ci = selectedMode === 'out' && Array.isArray((checkInData as any)?.[sk])
                  ? (checkInData as any)[sk].find((x: any) => x && x.key === it.key) : null;
                return sv ? { ...it, inOk: (ci?.inOk ?? sv.inOk) ?? false, out: sv.out ?? null, media: sv.media || [] }
                          : (ci ? { ...it, inOk: ci.inOk ?? false } : it);
              })
            : base;
        });
        return updated;
      });
    } else if (selectedMode === 'out' && checkInData) {
      // 🔥 FIX: No check-out data yet, but we have check-in data - use it as starting point
      console.log('🔄 Using check-in data as base for check-out');
      // 🔥 INDEPENDENCE FIX: reset inOk AND out — check-out starts clean
      setItems(mergeWithMaster(checkInData.items ? checkInData.items.map(item => ({ ...item, out: null })) : [], sectionKeys.kitchen, masterDefaults.kitchen));
      setNavItems(mergeWithMaster(checkInData.navItems ? checkInData.navItems.map(item => ({ ...item, out: null })) : [], sectionKeys.navigation, masterDefaults.navigation));
      setSafetyItems(mergeWithMaster(checkInData.safetyItems ? checkInData.safetyItems.map(item => ({ ...item, out: null })) : [], sectionKeys.safety_floorplan, masterDefaults.safety_floorplan));
      setGenItems(mergeWithMaster(checkInData.genItems ? checkInData.genItems.map(item => ({ ...item, out: null })) : [], sectionKeys.generator_floorplan, masterDefaults.generator_floorplan));
      setDeckItems(mergeWithMaster(checkInData.deckItems ? checkInData.deckItems.map(item => ({ ...item, out: null })) : [], sectionKeys.deck, masterDefaults.deck));
      setFdeckItems(mergeWithMaster(checkInData.fdeckItems ? checkInData.fdeckItems.map(item => ({ ...item, out: null })) : [], sectionKeys.fdeck, masterDefaults.fdeck));
      setDinghyItems(mergeWithMaster(checkInData.dinghyItems ? checkInData.dinghyItems.map(item => ({ ...item, out: null })) : [], sectionKeys.dinghy_floorplan, masterDefaults.dinghy_floorplan));
      setFendersItems(mergeWithMaster(checkInData.fendersItems ? checkInData.fendersItems.map(item => ({ ...item, out: null })) : [], sectionKeys.fenders, masterDefaults.fenders));
      setBoathookItems(mergeWithMaster(checkInData.boathookItems ? checkInData.boathookItems.map(item => ({ ...item, out: null })) : [], sectionKeys.boathook, masterDefaults.boathook));
      setDynamicSectionData(prev => {
        const upd: Record<string, any[]> = {};
        // 🔥 FIX: keys από prev ∪ dynamicSectionTitles (prev μπορεί να είναι {} σε 2ο mount)
        const allDynamicKeys = Array.from(new Set([...Object.keys(prev), ...Object.keys(dynamicSectionTitles)]));
        allDynamicKeys.forEach(sk => {
          const ci = (checkInData as any)?.[sk];
          // 🔥 FIX: αν prev[sk] κενό/undefined (2ο mount) → base = checkInData[sk], αλλιώς []
          const base = (prev[sk] && prev[sk].length) ? prev[sk] : (Array.isArray(ci) ? ci : []);
          upd[sk] = Array.isArray(ci)
            ? base.map(it => {
                const c = ci.find((x: any) => x && x.key === it.key);
                return c ? { ...it, inOk: c.inOk ?? false, out: null, media: c.media || [] }
                         : { ...it, out: null };
              })
            : base.map(it => ({ ...it, out: null }));
        });
        return upd;
      });
      setNotes("");
      setSignatureImage("");
    } else {
      // 🔥 PHASE 3.1 FIX: Keep Phase 3 DB-loaded items if already populated; only reset when truly empty
      setItems(prev => prev.length ? prev : mergeWithMaster([], sectionKeys.kitchen, masterDefaults.kitchen));
      setNavItems(prev => prev.length ? prev : mergeWithMaster([], sectionKeys.navigation, masterDefaults.navigation));
      setSafetyItems(prev => prev.length ? prev : mergeWithMaster([], sectionKeys.safety_floorplan, masterDefaults.safety_floorplan));
      setGenItems(prev => prev.length ? prev : mergeWithMaster([], sectionKeys.generator_floorplan, masterDefaults.generator_floorplan));
      setDeckItems(prev => prev.length ? prev : mergeWithMaster([], sectionKeys.deck, masterDefaults.deck));
      setFdeckItems(prev => prev.length ? prev : mergeWithMaster([], sectionKeys.fdeck, masterDefaults.fdeck));
      setDinghyItems(prev => prev.length ? prev : mergeWithMaster([], sectionKeys.dinghy_floorplan, masterDefaults.dinghy_floorplan));
      setFendersItems(prev => prev.length ? prev : mergeWithMaster([], sectionKeys.fenders, masterDefaults.fenders));
      setBoathookItems(prev => prev.length ? prev : mergeWithMaster([], sectionKeys.boathook, masterDefaults.boathook));
      setNotes("");
      setSignatureImage("");
    }
  };

  const initItems = (keys) => keys.map(key => ({ id: uid(), key, price: "", qty: 1, inOk: false, out: null, media: [] }));

  // Get hotspots - prefer API data, fallback to hardcoded
  const getHotspotsForVessel = (vesselId) => {
    // If API floorplan has hotspots, convert them for display
    if (apiFloorplan && apiFloorplan.hotspots && apiFloorplan.hotspots.length > 0) {
      console.log('📍 Using API hotspots for vessel:', vesselId);
      return apiFloorplan.hotspots.map(h => ({
        id: h.id,
        x: h.x, // DB/editor store normalized 0-1 (same scale as VESSEL_HOTSPOTS)
        y: h.y,
        title: h.title || h.label || 'ITEM',
        category: h.category || 'items'
      }));
    }
    // Fallback to hardcoded hotspots
    console.log('📍 Using fallback hotspots for vessel:', vesselId);
    return getHotspotsForVesselFallback(vesselId);
  };

  // Stage 5β: Dynamic section helpers
  const LEGACY_CATEGORIES = ['kitchen','navigation','safety_floorplan','generator_floorplan','deck','fdeck','dinghy_floorplan','fenders','boathook'];
  const isLegacyCategory = (cat: string) => LEGACY_CATEGORIES.includes(cat);

  const getSectionData = (category) => {
    const mapping = {
      items: items,
      navItems: navItems,
      safetyItems: safetyItems,
      genItems: genItems,
      deckItems: deckItems,
      fdeckItems: fdeckItems,
      dinghyItems: dinghyItems,
      fendersItems: fendersItems,
      boathookItems: boathookItems
    };
    return mapping[category] !== undefined ? mapping[category] : (dynamicSectionData[category] || []);
  };

  const LEGACY_SECTION_KEY_MAP = {
    items: 'kitchen',
    navItems: 'navigation',
    safetyItems: 'safety_floorplan',
    genItems: 'generator_floorplan',
    deckItems: 'deck',
    fdeckItems: 'fdeck',
    dinghyItems: 'dinghy_floorplan',
    fendersItems: 'fenders',
    boathookItems: 'boathook',
  };
  const getSectionTitle = () => {
    const titles = {
      items: ({en:'KITCHEN',el:'ΚΟΥΖΙΝΑ',it:'CUCINA',de:'KUCHE',ru:'КУХНЯ',fr:'CUISINE',ro:'BUCATARIE',pl:'KUCHNIA',he:'מטבח',es:'COCINA'})[lang] || 'KITCHEN',
      navItems: ({en:'NAVIGATION',el:'ΝΑΥΤΙΛΙΑ',it:'NAVIGAZIONE',de:'NAVIGATION',ru:'НАВИГАЦИЯ',fr:'NAVIGATION',ro:'NAVIGATIE',pl:'NAWIGACJA',he:'ניווט',es:'NAVEGACION'})[lang] || 'NAVIGATION',
      safetyItems: ({en:'SAFETY',el:'ΑΣΦΑΛΕΙΑ',it:'SICUREZZA',de:'SICHERHEIT',ru:'БЕЗОПАСНОСТЬ',fr:'SECURITE',ro:'SIGURANTA',pl:'BEZPIECZENSTWO',he:'בטיחות',es:'SEGURIDAD'})[lang] || 'SAFETY',
      genItems: ({en:'GENERATOR',el:'ΓΕΝΝΗΤΡΙΑ',it:'GENERATORE',de:'GENERATOR',ru:'ГЕНЕРАТОР',fr:'GENERATEUR',ro:'GENERATOR',pl:'GENERATOR',he:'גנרטור',es:'GENERADOR'})[lang] || 'GENERATOR',
      deckItems: ({en:'DECK',el:'ΚΑΤΑΣΤΡΩΜΑ',it:'PONTE',de:'DECK',ru:'ПАЛУБА',fr:'PONT',ro:'PUNTE',pl:'POKLAD',he:'סיפון',es:'CUBIERTA'})[lang] || 'DECK',
      fdeckItems: ({en:'FRONT DECK',el:'ΜΠΡΟΣΤΙΝΟ ΚΑΤΑΣΤΡΩΜΑ',it:'PONTE ANTERIORE',de:'VORDECK',ru:'НОСОВАЯ ПАЛУБА',fr:'PONT AVANT',ro:'PUNTE FATA',pl:'POKLAD DZIOBOWY',he:'סיפון קדמי',es:'CUBIERTA DELANTERA'})[lang] || 'FRONT DECK',
      dinghyItems: ({en:'DINGHY',el:'ΛΕΜΒΟΣ',it:'TENDER',de:'BEIBOOT',ru:'ТУЗИК',fr:'ANNEXE',ro:'BARCA',pl:'PONTON',he:'סירת גומי',es:'BOTE'})[lang] || 'DINGHY',
      fendersItems: ({en:'FENDERS',el:'ΜΠΑΛΟΝΙΑ',it:'PARABORDI',de:'FENDER',ru:'КРАНЦЫ',fr:'PARE-BATTAGES',ro:'APARATORI',pl:'ODBIJACZE',he:'פנדרים',es:'DEFENSAS'})[lang] || 'FENDERS',
      boathookItems: ({en:'BOAT-HOOK',el:'ΓΑΝΤΖΟΣ',it:'MEZZO MARINAIO',de:'BOOTSHAKEN',ru:'ОТПОРНЫЙ КРЮК',fr:'GAFFE',ro:'CANGE',pl:'BOSAK',he:'אנקול',es:'BICHERO'})[lang] || 'BOAT-HOOK'
    };
    const dynamicKey = LEGACY_SECTION_KEY_MAP[activeSection] || activeSection;
    const dynamicTitle = dynamicSectionTitles[dynamicKey] || dynamicSectionTitles[activeSection];
    return dynamicTitle || titles[activeSection] || '';
  };

  const isSectionComplete = (category) => {
    const data = getSectionData(category);
    if (data.length === 0) return false;
    
    if (mode === 'in') {
      return data.every(item => item.inOk);
    } else {
      return data.every(item => item.out === 'ok' || item.out === 'not');
    }
  };

  const LEGACY_SETTERS = { items:setItems, navItems:setNavItems, safetyItems:setSafetyItems,
    genItems:setGenItems, deckItems:setDeckItems, fdeckItems:setFdeckItems,
    dinghyItems:setDinghyItems, fendersItems:setFendersItems, boathookItems:setBoathookItems };
  const applyToSection = (section, updater) => {
    if (LEGACY_SETTERS[section]) LEGACY_SETTERS[section](updater);
    else setDynamicSectionData(prev => prev[section] ? { ...prev, [section]: updater(prev[section]) } : prev);
  };
  const setPrice = (section, id, value) => {
    
    applyToSection(section, prev => prev.map(it => it.id === id ? {...it, price: value} : it));
  };

  const incQty = (section, id) => {
    
    applyToSection(section, prev => prev.map(it => it.id === id ? {...it, qty: (it.qty || 1) + 1} : it));
  };

  const decQty = (section, id) => {
    
    applyToSection(section, prev => prev.map(it => it.id === id ? {...it, qty: Math.max(1, (it.qty || 1) - 1)} : it));
  };

  const toggleInOk = (section, id) => {
    
    applyToSection(section, prev => prev.map(it => it.id === id ? {...it, inOk: !it.inOk} : it));
  };

  const setOut = (section, id, value) => {
    
    applyToSection(section, prev => prev.map(it => it.id === id ? {...it, out: value} : it));
  };

  const handlers = {
    openCamera: (section, itemId) => {
      setCurrentItemId({ section, itemId });
      setShowCamera(true);
      setTimeout(async () => {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
          if (videoRef.current) videoRef.current.srcObject = stream;
        } catch (err) {
          console.error('Camera error:', err);
          alert(t.cameraError || 'Camera access denied');
        }
      }, 100);
    },
    handleFiles: async (section, itemId, files) => {
      const file = files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = async (e) => {
        const compressed = await compressImageWithLogging(e.target.result);
        
        
        applyToSection(section, prev => prev.map(it => it.id === itemId ? {...it, media: [...(it.media || []), { id: mid(), url: compressed }]} : it));
      };
      reader.readAsDataURL(file);
    },
    openFilePicker: (section, itemId) => {
      setCurrentItemId({ section, itemId });
      fileInputRef.current?.click();
    },
    removeRow: (section, id) => {
      if (window.confirm(t.confirmDelete || "Delete this item?")) {
        
        applyToSection(section, prev => prev.filter(it => it.id !== id));
      }
    }
  };

  const capturePhoto = async () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!canvas || !video || !currentItemId) return;
    
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0);
    
    const base64 = canvas.toDataURL('image/jpeg', 0.8);
    const compressed = await compressImageWithLogging(base64);
    
    const { section, itemId } = currentItemId;
    
    applyToSection(section, prev => prev.map(it => it.id === itemId ? {...it, media: [...(it.media || []), { id: mid(), url: compressed }]} : it));
    
    const stream = video.srcObject;
    stream?.getTracks().forEach(track => track.stop());
    setShowCamera(false);
  };

  const closeCamera = () => {
    const video = videoRef.current;
    const stream = video?.srcObject;
    stream?.getTracks().forEach(track => track.stop());
    setShowCamera(false);
  };

  const removeMedia = (section, itemId, mediaId) => {
    
    applyToSection(section, prev => prev.map(it => it.id === itemId ? {...it, media: it.media.filter(m => m.id !== mediaId)} : it));
  };

  const allItems = [...items, ...navItems, ...safetyItems, ...genItems, ...deckItems, ...fdeckItems, ...dinghyItems, ...fendersItems, ...boathookItems];
  const totalItems = allItems.length;
  let completedItems = 0;
  if (mode === "in") {
    completedItems = allItems.filter((it) => it.inOk).length;
  } else {
    completedItems = allItems.filter((it) => it.out === "ok" || it.out === "not").length;
  }
  const percentage = totalItems > 0 ? Math.round((completedItems / totalItems) * 100) : 0;

  const addItem = (section, newItemValue, setNewItemValue) => {
    if (!newItemValue.trim()) {
      alert(t.enterItemName || 'Enter item name!');
      return;
    }
    
    
    const newKey = newItemValue.trim();
    applyToSection(section, prev => [...prev, {id: uid(), key: newKey, price: "", qty: 1, inOk: false, out: null, media: []}]);
    setNewItemValue("");
  };

  const handleEmployeeLogin = () => {
    const user = authService.login(employeeCode);
    if (user) {
      setIsEmployee(true);
      setCurrentEmployee(user.permissions);
      setShowLoginModal(false);
      setEmployeeCode("");
    } else {
      alert(t.invalidCode || 'Invalid code');
    }
  };

  const handleEmployeeLogout = () => {
    setIsEmployee(false);
    setCurrentEmployee(null);
  };

  const handleSave = async () => {
    if (!isEmployee || !currentEmployee?.canEdit) {
      alert(t.employeeRequired || '🔒 Employee permissions required!');
      return;
    }

    const dataToSave = {
      items,
      navItems,
      safetyItems,
      genItems,
      deckItems,
      fdeckItems,
      dinghyItems,
      fendersItems,
      boathookItems,
      ...dynamicSectionData,
      notes,
      signatureImage
    };

    // 🔥 Save media to localStorage separately (API may not store large base64 images)
    const allPage4Items = [...items, ...navItems, ...safetyItems, ...genItems, ...deckItems, ...fdeckItems, ...dinghyItems, ...fendersItems, ...boathookItems, ...Object.values(dynamicSectionData).flat()];
    savePageMedia(currentBookingNumber, mode, 'page4', allPage4Items);

    // ✅ Save to Page 4 API using hybrid function
    try {
      const result = await savePage2DataHybrid(currentBookingNumber, dataToSave, mode);

      if (result.synced) {
        alert(t.draftSavedSynced || '✅ Saved and synced!');
      } else {
        alert(t.draftSavedLocally || '✅ Saved locally!');
      }
    } catch (error) {
      console.error('Error saving:', error);
      alert(t.saveError || '❌ Save error!');
    }
  };

  // 🔥 NEW: handlePDF function
  const handlePDF = () => {
    if (!bookingInfo) {
      alert(t.noActiveBooking || '❌ No active booking!');
      return;
    }

    try {
      const { generateLuxuryPDF } = require('./utils/LuxuryPDFGenerator');
      
      // Read signature from localStorage
      const signatureKey = `page4_signature_${currentBookingNumber}_${mode}`;
      const actualSignature = localStorage.getItem(signatureKey) || '';
      
      // Get vessel name and floorplan (prefer API, fallback to hardcoded)
      const vesselName = VESSELS.find(v => v.id === selectedVessel)?.name || selectedVessel;
      const floorplanPath = apiFloorplan?.background_image || VESSEL_FLOORPLANS[selectedVessel];
      
      const additionalData = {
        // 9 sections
        kitchen: items,
        navigation: navItems,
        safety: safetyItems,
        generator: genItems,
        deck: deckItems,
        frontDeck: fdeckItems,
        dinghy: dinghyItems,
        fenders: fendersItems,
        boathook: boathookItems,
        
        // Vessel info
        vesselName: vesselName,
        floorplanPath: floorplanPath,
        
        skipperSignature: actualSignature
      };
      
      const pdf = generateLuxuryPDF(
        bookingInfo,
        mode,
        additionalData,
        lang,
        { isPage4: true }
      );
      
      const fileName = `${bookingInfo.bookingNumber || 'booking'}_Page4_${mode}_${Date.now()}.pdf`;
      pdf.save(fileName);
      
      alert(t.pdfGenerated || '✅ PDF generated!');
    } catch (error) {
      console.error('PDF generation error:', error);
      alert(t.pdfError || '❌ PDF generation error!');
    }
  };

  const handlePrevious = () => {
    // 🔒 v6.462: ο ΠΕΛΑΤΗΣ δεν πρέπει ΠΟΤΕ να δει τη σελ.1 → γυρνάει HomePage
    // με το booking param, ώστε να μείνει ξεκλείδωτο το Pre-Fill (χωρίς νέο κωδικό).
    // STAFF (isEmployee): αμετάβλητο → onNavigate('prev') → /page1.
    if (!isEmployee) {
      const bn = currentBookingNumber || (typeof window !== 'undefined' ? localStorage.getItem('currentBooking') : '') || '';
      navigate(bn ? `/home?booking=${encodeURIComponent(bn)}` : '/home');
      return;
    }
    if (onNavigate && typeof onNavigate === 'function') {
      onNavigate('prev');
    }
  };

  const handleSelectAllOk = () => {
    const confirmed = window.confirm(t.selectAllOkConfirm || 'Under my own responsibility I declare all items are correct. Continue?');
    if (!confirmed) return;
    const toOk = (arr) => arr.map(it => mode === 'in' ? { ...it, inOk: true } : { ...it, out: 'ok' });
    setItems(toOk);
    setNavItems(toOk);
    setSafetyItems(toOk);
    setGenItems(toOk);
    setDeckItems(toOk);
    setFdeckItems(toOk);
    setDinghyItems(toOk);
    setFendersItems(toOk);
    setBoathookItems(toOk);
    setDynamicSectionData(prev =>
      Object.fromEntries(Object.entries(prev).map(([k, v]) => [k, toOk(v)])));
  };

  const handleNext = async () => {
    if (activeSection) {
      setActiveSection(null);
      return;
    }

    if (SHOW_PER_PAGE_SIGNATURES && !signatureImage) {
      alert(t.signatureRequired || 'Please provide signature!');
      return;
    }

    const dataToSave = {
      items,
      navItems,
      safetyItems,
      genItems,
      deckItems,
      fdeckItems,
      dinghyItems,
      fendersItems,
      boathookItems,
      ...dynamicSectionData,
      notes,
      signatureImage
    };

    try {
      await savePage2DataHybrid(currentBookingNumber, dataToSave, mode);

      if (onNavigate && typeof onNavigate === 'function') {
        onNavigate('next');
      }
    } catch (error) {
      alert(t.saveError || 'Save error!');
    }
  };

  const allMedia = allItems.reduce((acc, item) => {
    if (item.media && item.media.length > 0) {
      return [...acc, ...item.media.map(m => ({ ...m, itemKey: item.key }))];
    }
    return acc;
  }, []);

  const completedSectionsCount = () => {
    const sections = ['items', 'navItems', 'safetyItems', 'genItems', 'deckItems', 'fdeckItems', 'dinghyItems', 'fendersItems', 'boathookItems'];
    return sections.filter(section => isSectionComplete(section)).length;
  };

  return (
    <div className="min-h-screen p-4" style={{ backgroundColor: brand.pageBg }}>
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg p-6">
        {SHOW_BOOKING_INFO_ON_CHECKLIST_PAGES && <BookingInfoBox bookingInfo={bookingInfo} currentBookingNumber={currentBookingNumber} />}
        <TailwindButton />
          <PageHeader title={t.boatInventoryMap || 'BOAT INVENTORY - INTERACTIVE MAP'} />
        <ModeDisplay mode={mode} t={t} />
        <TopControls
          isOnline={isOnline}
          lang={lang}
          setLang={setLang}
          isEmployee={isEmployee}
          currentEmployee={currentEmployee}
          onEmployeeLogout={handleEmployeeLogout}
          onEmployeeLogin={() => setShowLoginModal(true)}
          percentage={percentage}
          hideEmployeeLogin={true}
          hideEmployeeLogout={true}
        />

        <input 
          ref={fileInputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => currentItemId && handlers.handleFiles(currentItemId.section, currentItemId.itemId, e.target.files)}
        />


        <div className="mb-4 text-center">
          <button
            onClick={handleSelectAllOk}
            className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg shadow-md"
          >
            ✓ {t.selectAllOk || 'SELECT ALL OK'}
          </button>
        </div>
        {!activeSection ? (
          <div>
            <div className="mb-6 bg-white rounded-xl p-4 border-2" style={{ borderColor: brand.blue }}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-semibold" style={{ color: brand.black }}>
                  {t.progress || 'Progress'}
                </span>
                <span className="text-sm font-bold" style={{ color: brand.blue }}>
                  {completedSectionsCount()}/9 {t.sectionsCompleted || 'sections completed'}
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3">
                <div 
                  className="bg-green-500 h-3 rounded-full transition-all duration-500"
                  style={{ width: (completedSectionsCount() / 9 * 100) + '%' }}
                />
              </div>
            </div>

            <div className="relative bg-white rounded-xl p-4 border-2" style={{ borderColor: brand.blue }}>
              <div className="text-center mb-2 text-sm font-semibold" style={{ color: brand.black }}>
                {t.clickHotspot || 'Click on any hotspot to view inventory'}
              </div>
              
              <div className="relative inline-block w-full">
                <div className="relative w-full" style={{ paddingTop: '60%' }}>
                  
                  {!selectedVessel ? (
                    <div className="absolute inset-0 w-full h-full flex items-center justify-center bg-gray-100 rounded-lg">
                      <div className="text-center">
                        <p className="text-gray-500 text-sm">Loading vessel…</p>
                      </div>
                    </div>
                  ) : !imageError ? (
                    <img
                      src={apiFloorplan?.background_image || VESSEL_FLOORPLANS[selectedVessel] || VESSEL_FLOORPLANS['bob']}
                      alt={selectedVessel + ' floorplan'}
                      className="absolute inset-0 w-full h-full object-contain rounded-lg"
                      onError={(e) => {
                        console.error('❌ Floorplan image failed to load:', e.currentTarget.src);
                        setImageError(true);
                      }}
                      onLoad={() => console.log('✅ Floorplan image loaded:', selectedVessel)}
                    />
                  ) : (
                    <div className="absolute inset-0 w-full h-full flex items-center justify-center bg-gray-100 rounded-lg">
                      <div className="text-center">
                        <p className="text-gray-500 text-sm">
                          {t.floorplanNotAvailable || 'Floorplan not available for this vessel'}
                        </p>
                        <p className="text-gray-400 text-xs mt-1">{VESSELS.find(v => v.id === selectedVessel)?.name}</p>
                      </div>
                    </div>
                  )}
                  
                  {getHotspotsForVessel(selectedVessel).map(hotspot => (
                    <button
                      key={hotspot.id}
                      onClick={() => setActiveSection(hotspot.category)}
                      onMouseEnter={() => setHoveredHotspot(hotspot.id)}
                      onMouseLeave={() => setHoveredHotspot(null)}
                      className="absolute transform -translate-x-1/2 -translate-y-1/2 group"
                      style={{ left: (hotspot.x * 100) + '%', top: (hotspot.y * 100) + '%', zIndex: 10 }}
                    >
                      <span className="absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75 animate-ping"></span>
                      <span className={isSectionComplete(hotspot.category) 
                        ? "relative inline-flex h-4 w-4 md:h-5 md:w-5 rounded-full bg-green-600 border-2 border-white shadow-lg hover:scale-125 transition-transform" 
                        : "relative inline-flex h-4 w-4 md:h-5 md:w-5 rounded-full bg-red-600 border-2 border-white shadow-lg hover:scale-125 transition-transform"}
                      ></span>
                      
                      {isSectionComplete(hotspot.category) && (
                        <span className="absolute -top-1 -right-1 w-5 h-5 bg-green-500 text-white rounded-full flex items-center justify-center text-xs font-bold shadow-lg">
                          ✓
                        </span>
                      )}
                      
                      <span className={hoveredHotspot === hotspot.id 
                        ? 'absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs font-bold text-white bg-gray-800 rounded whitespace-nowrap transition-opacity opacity-100' 
                        : 'absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs font-bold text-white bg-gray-800 rounded whitespace-nowrap transition-opacity opacity-0 pointer-events-none'}
                      >
                        {dynamicSectionTitles[LEGACY_SECTION_KEY_MAP[hotspot.category] || hotspot.category] || hotspot.title}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="flex items-center justify-between mb-4">
              <button 
                onClick={() => setActiveSection(null)} 
                className="px-4 py-2 rounded border flex items-center gap-2 hover:bg-gray-100" 
                style={{ borderColor: brand.black, color: brand.black }}
              >
                ← {t.backToMap || 'Back to Map'}
              </button>
              <h2 className="text-xl font-bold" style={{ color: brand.black }}>
                {getSectionTitle()}
              </h2>
            </div>

            <TableSection 
              data={getSectionData(activeSection)} 
              t={t} 
              setPrice={(id, value) => setPrice(activeSection, id, value)}
              incQty={(id) => incQty(activeSection, id)}
              decQty={(id) => decQty(activeSection, id)}
              toggleInOk={(id) => toggleInOk(activeSection, id)}
              setOut={(id, value) => setOut(activeSection, id, value)}
              openCamera={(id) => handlers.openCamera(activeSection, id)}
              handleFiles={(id, files) => handlers.handleFiles(activeSection, id, files)}
              openFilePicker={(id) => handlers.openFilePicker(activeSection, id)}
              removeRow={(id) => handlers.removeRow(activeSection, id)}
              mode={mode}
              getLabel={(key) => getLabel(key, lang)}
              isEmployee={isEmployee}
              currentEmployee={currentEmployee}
              newItem={
                activeSection === 'items' ? newKitchenItem :
                activeSection === 'navItems' ? newNavItem :
                activeSection === 'safetyItems' ? newSafetyItem :
                activeSection === 'genItems' ? newGenItem :
                activeSection === 'deckItems' ? newDeckItem :
                activeSection === 'fdeckItems' ? newFdeckItem :
                activeSection === 'dinghyItems' ? newDinghyItem :
                activeSection === 'fendersItems' ? newFendersItem :
                newBoathookItem
              }
              setNewItem={
                activeSection === 'items' ? setNewKitchenItem :
                activeSection === 'navItems' ? setNewNavItem :
                activeSection === 'safetyItems' ? setNewSafetyItem :
                activeSection === 'genItems' ? setNewGenItem :
                activeSection === 'deckItems' ? setNewDeckItem :
                activeSection === 'fdeckItems' ? setNewFdeckItem :
                activeSection === 'dinghyItems' ? setNewDinghyItem :
                activeSection === 'fendersItems' ? setNewFendersItem :
                setNewBoathookItem
              }
              addItem={() => addItem(
                activeSection,
                activeSection === 'items' ? newKitchenItem :
                activeSection === 'navItems' ? newNavItem :
                activeSection === 'safetyItems' ? newSafetyItem :
                activeSection === 'genItems' ? newGenItem :
                activeSection === 'deckItems' ? newDeckItem :
                activeSection === 'fdeckItems' ? newFdeckItem :
                activeSection === 'dinghyItems' ? newDinghyItem :
                activeSection === 'fendersItems' ? newFendersItem :
                newBoathookItem,
                activeSection === 'items' ? setNewKitchenItem :
                activeSection === 'navItems' ? setNewNavItem :
                activeSection === 'safetyItems' ? setNewSafetyItem :
                activeSection === 'genItems' ? setNewGenItem :
                activeSection === 'deckItems' ? setNewDeckItem :
                activeSection === 'fdeckItems' ? setNewFdeckItem :
                activeSection === 'dinghyItems' ? setNewDinghyItem :
                activeSection === 'fendersItems' ? setNewFendersItem :
                setNewBoathookItem
              )}
              readOnly={isFrozen}
              markProblematic={true}
              sectionTitle={getSectionTitle()}
            />
          </div>
        )}

        {activeSection && (
        <div className="mt-6 border-2 rounded-xl p-4" style={{ borderColor: brand.blue }}>
          <label className="block font-semibold" style={{ color: brand.black }}>{t.note}</label>
          <textarea 
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className="mt-2 w-full border rounded p-3 min-h-[180px] bg-white" 
            placeholder={t.notePH} 
            style={{ borderColor: brand.black, color: brand.black }} 
          />
        </div>
        )}

        {activeSection && (allMedia.length > 0 ? (
          <div className="mt-6 border-2 rounded-xl p-4" style={{ borderColor: brand.blue }}>
            <label className="block font-semibold mb-3" style={{ color: brand.black }}>
              {t.picsTitle}
            </label>
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
              {allMedia.map((media) => (
                <div key={media.id} className="relative border-2 rounded-lg overflow-hidden" style={{ borderColor: brand.black }}>
                  <img 
                    src={media.url} 
                    alt={getLabel(media.itemKey, lang)}
                    className="w-full h-24 object-cover cursor-pointer"
                    onClick={() => setZoomUrl(media.url)}
                  />
                  <div className="absolute top-1 right-1 flex gap-1">
                    <button 
                      onClick={() => setZoomUrl(media.url)}
                      className="bg-white rounded-full p-1 shadow-md hover:bg-gray-100"
                    >
                      🔍
                    </button>
                    <button 
                      onClick={() => {
                        // Find the correct section and item
                        const sectionMappings = [
                          { section: 'items', data: items },
                          { section: 'navItems', data: navItems },
                          { section: 'safetyItems', data: safetyItems },
                          { section: 'genItems', data: genItems },
                          { section: 'deckItems', data: deckItems },
                          { section: 'fdeckItems', data: fdeckItems },
                          { section: 'dinghyItems', data: dinghyItems },
                          { section: 'fendersItems', data: fendersItems },
                          { section: 'boathookItems', data: boathookItems }
                        ];
                        
                        for (const { section, data } of sectionMappings) {
                          const item = data.find(it => it.key === media.itemKey);
                          if (item) {
                            removeMedia(section, item.id, media.id);
                            break;
                          }
                        }
                      }}
                      className="bg-white rounded-full p-1 shadow-md hover:bg-red-100"
                    >
                      ✕
                    </button>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white text-xs px-2 py-1 truncate">
                    {getLabel(media.itemKey, lang)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="mt-6 border-2 rounded-xl p-4 text-center" style={{ borderColor: brand.blue }}>
            <label className="block font-semibold mb-2" style={{ color: brand.black }}>
              {t.picsTitle}
            </label>
            <p className="text-gray-400 text-sm">
              {t.noPhotos || 'No photos added yet.'}
            </p>
          </div>
        ))}

        {!activeSection && (
          <>
            {SHOW_PER_PAGE_SIGNATURES && (
              <SignatureBox
                brand={brand}
                lang={lang}
                onSignChange={setSignatureImage}
                onImageChange={setSignatureImage}
                initialImage={signatureImage}
                currentBookingNumber={currentBookingNumber}
                mode={mode}
                pageNumber={4}
              />
            )}
          </>
        )}

        <ActionButtons 
          onPrevious={handlePrevious}
          onSave={handleSave}
          onPDF={handlePDF}
          onNext={handleNext}
          t={t}
        />

      </div>

      {showCamera && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 max-w-2xl w-full">
            <h3 className="text-xl font-bold mb-4" style={{ color: brand.black }}>Camera</h3>
            <video ref={videoRef} autoPlay playsInline className="w-full rounded-lg mb-4" style={{ maxHeight: '60vh' }} />
            <canvas ref={canvasRef} className="hidden" />
            <div className="flex gap-3">
              <button 
                onClick={capturePhoto} 
                className="flex-1 px-6 py-3 rounded-lg font-semibold text-white flex items-center justify-center gap-2" 
                style={{ backgroundColor: brand.blue }}
              >
                📸 {lang === 'el' ? 'Λήψη' : 'Capture'}
              </button>
              <button 
                onClick={closeCamera} 
                className="px-6 py-3 rounded-lg font-semibold border-2"
                style={{ borderColor: brand.black, color: brand.black }}
              >
                {lang === 'el' ? 'Κλείσιμο' : 'Close'}
              </button>
            </div>
          </div>
        </div>
      )}

      {zoomUrl && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4" onClick={() => setZoomUrl(null)}>
          <img src={zoomUrl} alt="Zoomed" className="max-w-[90%] max-h-[90%] rounded-lg shadow-2xl" />
        </div>
      )}
    </div>
  );
}
